import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useNotifications } from "@/features/notifications/hooks/useNotifications";
import { resolveNotificationSectionForPath } from "@/features/notifications/lib/notificationSectionCounts";

/** Marque comme lues les notifications de la section quand l'utilisateur ouvre la page correspondante. */
export function useAutoMarkSectionNotificationsRead(): void {
  const location = useLocation();
  const { markSectionRead } = useNotifications();
  const markSectionReadRef = useRef(markSectionRead);
  markSectionReadRef.current = markSectionRead;

  useEffect(() => {
    const section = resolveNotificationSectionForPath(location.pathname);
    if (!section) {
      return;
    }
    void markSectionReadRef.current(section);
    // Uniquement au changement de route — pas quand markSectionRead change (ex. refresh WS).
  }, [location.pathname]);
}
